import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.memberFee', {
    // /context/:ctxId/groups/:groupId/memberfees
    // :ctxId = ancestor/context group, :groupId = group
      url: '/memberfees',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.memberFee.list', {
      url: '',
      template: listTemplate,
      controller: 'MemFeeListCtrl',
      controllerAs: 'mfvm',
      authenticate: true
    })
    .state('group.view.settings.memberFee.new', {
      url: '/new',
      template: formTemplate,
      controller: 'MemFeeFormCtrl',
      controllerAs: 'mfvm',
      authenticate: true
    })
    .state('group.view.settings.memberFee.view', {
      url: '/:mfId',
      template: viewTemplate,
      controller: 'MemFeeViewCtrl',
      controllerAs: 'mfvm',
      authenticate: true
    })
    .state('group.view.settings.memberFee.edit', {
      url: '/:mfId/edit',
      controller: 'MemFeeFormCtrl',
      controllerAs: 'mfvm',
      authenticate: true
    });
}];
